// @ts-strict-ignore
import type { Module } from 'vuex'

import type { AuthState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'

import { LoadStateFromStorageAction } from './actions/load-state-from-storage.action'
import { LoginAction } from './actions/login.action'
import { LogoutAction } from './actions/logout.action'
import { RefreshAction } from './actions/refresh.action'
import { SetTokenAction } from './actions/set-token.action'
import { AUTH_CONSTS } from './auth.consts'
import { IsLoggedInGetter } from './getters/is-logged-in.getter'
import { KeepLoggedInGetter } from './getters/keep-logged-in.getter'
import { TokenInfoGetter } from './getters/token-info.getter'
import { TokenGetter } from './getters/token.getter'
import { SetStateMutation } from './mutations/set-state.mutation'

export const AUTH_MODULE: Module<AuthState, any> = {
  namespaced: true,

  initialState: (): AuthState => {
    return {
      token: undefined,
      refreshToken: undefined,
      keepLoggedIn: false,
    }
  },
  state: (): AuthState => AUTH_MODULE.initialState(),

  getters: {
    [AUTH_CONSTS.getters.token]: TokenGetter.execute,
    [AUTH_CONSTS.getters.tokenInfo]: TokenInfoGetter.execute,
    [AUTH_CONSTS.getters.isLoggedIn]: IsLoggedInGetter.execute,
    [AUTH_CONSTS.getters.keepLoggedIn]: KeepLoggedInGetter.execute,
  },

  actions: {
    [AUTH_CONSTS.actions.loadStateFromStorage]: LoadStateFromStorageAction.execute,
    [AUTH_CONSTS.actions.login]: LoginAction.execute,
    [AUTH_CONSTS.actions.logout]: LogoutAction.execute,
    [AUTH_CONSTS.actions.refresh]: RefreshAction.execute,
    [AUTH_CONSTS.actions.setToken]: SetTokenAction.execute,

    [AUTH_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, AUTH_MODULE.initialState()),
  },

  mutations: {
    [AUTH_CONSTS.mutations.setState]: SetStateMutation.execute,
    [AUTH_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
